/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import { DEFAULT_CURRENCY } from '../locales';
import * as Permission from "../util/Permission";


export const BILLING_OPERATION_REPLACE = "REPLACE";
export const BILLING_OPERATION_ADD = "ADD";

export const billingOperationType = {
    [BILLING_OPERATION_REPLACE]: {
        name: "Replace",
    },
    [BILLING_OPERATION_ADD]: {
        name: "Add",
    },
};

export default declareLinkedEntity({
    entity: "flowBillingRules",
    graphQL: "FlowBillingRule",
    name: "Flow Billing Rule",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "flowBillingRules",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['flowDef'],
    fields: (types) => { return {
        id: {
            name: "Flow Billing Rule ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ["flowDefVersion"],
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        operationType: {
            name: "Operation Type",
            type: "enum",
            defaultValue: BILLING_OPERATION_REPLACE,
            values: billingOperationType,
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        priority: {
            name: "Priority",
            type: "number",
            defaultValue: 1,
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        validSince: {
            name: "Valid Since",
            type: "date",
        },
        validTo: {
            name: "Valid To",
            type: "date",
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            translatable: true,
            required: true,
        },
        channelDef: {
            name: "Related Application Definition",
            description: "Special prices for this flow for this application",
            to: () => types['channelDefs'],
            type: "relation",
        },
        relatedFlowDef: {
            name: "Related Flow in same organisation",
            description: "Some flows have a special price if used with another flow in the same organisation.",
            to: () => types['flowDefs'],
            type: "relation",
        },
        overridePriceInstallation: {
            name: "Installation Price",
            type: "number",
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePriceInstallationNext: {
            name: "Installation Price (another)",
            type: "number",
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePricePerInvocation: {
            name: "Price per invocation",
            type: "number",
            addonAfter: DEFAULT_CURRENCY,
        },
        overrideTablePerInvocation: {
            name: "Table per invocation",
            type: "string",
        },
        overridePricePerInstance: {
            name: "Price per instance",
            type: "number",
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePricePerInstanceNext: {
            name: "Price per instance (more)",
            type: "number",
            addonAfter: DEFAULT_CURRENCY,
        },
        overrideMinPrice: {
            name: "Minimum Price",
            type: "number",
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePriceText: {
            name: "Price text",
            type: "string",
            description: "Text showed to the user instead of computed text from price parameters. You can use pricePerInstance, pricePerInstanceNext, pricePerInvocation, priceInstallation, invocationName.",
            isPublic: true,
            translatable: true,
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
